// Reception.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaClock, FaUtensils, FaGlassCheers, FaMusic, FaBirthdayCake, FaMapMarkedAlt, FaCamera } from 'react-icons/fa';
import './Reception.css';
import receptionImage from '../../images/wedding/reception.jpg';

const Reception = () => {
    const { t } = useTranslation();

    const handleMapClick = (e) => {
        e.preventDefault();
        const address = encodeURIComponent('Jernbanevegen 26, 2900 Fagernes, Norge');
        window.open(`https://www.google.com/maps/search/?api=1&query=${address}`, '_blank');
    };

    return (
        <section className="reception-section">
            <div className="reception-container">
                <div className="reception-content">
                    <h2 className="reception-title">{t('reception.title')}</h2>

                    <div className="reception-details">
                        {/* Mingling and Photography Time */}
                        <p className="reception-timing"><FaCamera className="icon" /> {t('reception.mingling')}</p>

                        {/* Dinner Information */}
                        <div className="venue-details">
                            <p className="reception-timing"><FaUtensils className="icon" /> {t('reception.dinner')}</p>
                            <p className="reception-invite"><FaUtensils className="icon" /> {t('reception.buffet')}</p>
                        </div>

                        {/* Party Details */}
                        <div className="venue-details">
                            <p className="venue-instructions"><FaClock className="icon" /> {t('reception.partyTime')}</p>
                            <p className="venue-instructions"><FaMusic className="icon" /> <FaGlassCheers className="icon" /> <FaBirthdayCake className="icon" /> {t('reception.activities')}</p>
                        </div>

                        {/* Map Link */}
                        <a href="#" className="map-link" onClick={handleMapClick}>
                            <FaMapMarkedAlt className="icon" /> {t('reception.mapLink')}
                        </a>
                    </div>
                </div>

                <div className="reception-image">
                    <img src={receptionImage} alt={t('reception.imageAlt')} />
                </div>
            </div>
        </section>
    );
};

export default Reception;